import { getUnauthenticated } from '@auth0spa/services/utility/Requests.default';

import {
    IProductPricesWithDiscounts,
    ISkuPackage,
} from '../util/interfaces/ecommerce';

export const billingUrl = 'ecommerce_/api';

export async function getSkuPackagesForUsBillingEntity(portalDomain: string) {
    return await getUnauthenticated<ISkuPackage[]>(`${portalDomain}/${billingUrl}/sku-package-prices?countrycode=US`);
}

export async function getPricesWithDiscountsForUsBillingEntity(
    portalDomain: string,
    productConfigListRequest: string[],
    discountId?: string) {
    let url = `${portalDomain}/${billingUrl}/prices-with-discounts?currency=USD&productCodes=` +
        `${productConfigListRequest.sort().join(',')}`;
    if (discountId) {
        url += `&discountId=${discountId}`;
    }
    return await getUnauthenticated<IProductPricesWithDiscounts>(url);
}
